import { render, staticRenderFns } from "./About1.vue?vue&type=template&id=67bc98f0&scoped=true&"
import script from "./About1.vue?vue&type=script&lang=js&"
export * from "./About1.vue?vue&type=script&lang=js&"
import style0 from "./About1.vue?vue&type=style&index=0&id=67bc98f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc98f0",
  null
  
)

export default component.exports